export default {
  title: 'Orders Portal',
  form: {
    username: {
      placeholder: 'Nombre de usuario',
    },
    password: {
      placeholder: 'Contraseña',
    },
  },
  buttons: {
    submit: 'Iniciar sesión',
  },
  toasts: {
    auth_token_invalid: 'El token de autenticación no es válido, inicia sesión con tus credenciales',
    credentials_invalid: 'Usuario o contraseña incorrectos',
  },
};
